import { User } from './User'
import { DataObject } from '@/utils/DataObject';
import { MediaTransformer } from '../media/MediaTransformer';
import { Artist } from '../artist/Artist'


export class UserTransformer {

  public toClass(data: DataObject = {}): User {
    console.log("toClass", data);

    return new User({
      id: data.id,
      name: data.name,
      email: data.email,
      phone: data.phone,
      firstName: data.first_name || data.firstName,
      lastName: data.last_name || data.lastName,
      lastLogin: data.last_login || data.lastLogin,
      artworksDraftCount: data.artworks_draft_count !== undefined ? data.artworks_draft_count : data.artworksDraftCount,
      artworksPublishedCount: data.artworks_published_count !== undefined ? data.artworks_published_count : data.artworksPublishedCount,
      favoritesCount: data.favorites_count !== undefined ? data.favorites_count : data.favoritesCount,
      subscriptions_count: data.subscriptions_count !== undefined ? data.subscriptions_count : data.subscriptionsCount,
      purchasesCount: data.purchases_count !== undefined ? data.purchases_count : data.purchasesCount,
      salesCount: data.sales_count !== undefined ? data.sales_count : data.salesCount,
      isAdmin: data.is_admin || data.isAdmin || false,
      isArtist: data.is_artist || data.isArtist || false,
      isLatestTermsAccepted: data.is_latest_terms_accepted || data.isLatestTermsAccepted || false,
      media: data.media ? new MediaTransformer().toClass(data.media) : null,
      addressline1: data.addressline_1 || data.addressline1,
      city: data.city,
      zip: data.zip,
      countryId: data.country_id || data.countryId,
      status: data.status,
      artist_id: data.artist_id
    })
  }
}
